// removed by extract-text-webpack-plugin
module.exports = {"dashboard-details-grid":"src-components----DashboardDetailsGrid-module---dashboard-details-grid---2rGhB","cell":"src-components----DashboardDetailsGrid-module---cell---1RO-E","heading":"src-components----DashboardDetailsGrid-module---heading---17arM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DashboardDetailsGrid.module.scss
// module id = 654
// module chunks = 65120233804887